import script from "./geps-awb-form.vue?vue&type=script&setup=true&lang=js"
export * from "./geps-awb-form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__